import { ToastPluginOptions as s } from "./toast-plugin-options.js";
import n from "vue-toastification";
import { ToastService as r } from "../service/toast-service.js";
import { ToastServiceInjectionFacade as a } from "../../injection/toast-service-injection-facade.js";
class u {
  toastPluginOptions;
  constructor(t) {
    this.toastPluginOptions = t, this.importToastificationCss(), this.importStandardStyles();
  }
  importToastificationCss() {
    import("vue-toastification/dist/index.css?used");
  }
  importStandardStyles() {
    import("./styles/toast-notification.scss.js");
  }
  async install(t) {
    const o = new s(
      this.toastPluginOptions
    ).configurePluginOptions(), i = new r();
    new a().provideToApp(i, t), t.use(n, o);
  }
}
export {
  u as ToastPlugin
};
//# sourceMappingURL=toast-plugin.js.map
